import type { FunctionComponent } from 'react'

import styled from 'styled-components'

import type { FlowStepData } from '../../../pages/LandingPage/flowStepUtils'

import { FlowStepSubGroup } from '../../../pages/LandingPage/flowStepUtils'
import { FlowStepDisclosureCard } from './FlowStepDisclosureCard'

const FlowStepsContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 16px;

	${(props) => props.theme.breakpoints.up('sm')} {
		width: 800px;
		max-width: 100%;
		gap: 12px;
	}
`

const FlowStep = ({
	idx,
	flowStep,
	clientName,
}: {
	idx: number
	flowStep: FlowStepData
	clientName: string
}) => {
	return (
		<FlowStepDisclosureCard
			idx={idx}
			flowStep={flowStep}
			clientName={clientName}
		/>
	)
}

export const FlowSteps: FunctionComponent<{
	flowSteps: FlowStepData[]
	clientName: string
	children?: never
}> = ({ flowSteps, clientName }) => {
	return (
		<FlowStepsContainer>
			{flowSteps.map((step, index) => (
				<FlowStep
					key={`FLOW_STEP_${FlowStepSubGroup[step.subGroup]}`}
					idx={index + 1}
					flowStep={step}
					clientName={clientName}
				/>
			))}
		</FlowStepsContainer>
	)
}
